
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/assistencia/contato",
      function () {
        return require("private-next-pages/assistencia/contato.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/assistencia/contato"])
      });
    }
  